import axios from 'axios';
import axiosRetry from 'axios-retry';
import qs from 'qs';

export default {
    install(Vue, { locale = 'en' }) {
        const axiosInstance = axios.create({
            headers: {
                common: {
                    'Accept': 'application/json, text/plain, */*',
                    'Accept-Language': locale,
                    'X-Requested-With': 'XMLHttpRequest',
                },
            },
            paramsSerializer(params) {
                return qs.stringify(params, {
                    arrayFormat: 'brackets',
                    encodeValuesOnly: true,
                });
            },
        });

        axiosRetry(axiosInstance, { retries: 3 });

        Vue.axios = axiosInstance;
        Vue.prototype.$axios = axiosInstance;
    },
};
